import * as isNumber from 'lodash/isNumber'
import { SimpleGuard, WatchingGuard } from 'interfaces/guards'
import { ActivePeergroupsTyped } from 'interfaces/peergroups'
import { getMemberGenericTrendsActionCreator, getPeergroupsGenericTrendsActionCreator } from 'actions/genericActions'
import { hasPeergroupGenericTrendsSelector, hasMemberGenericTrendSelector } from 'selectors/genericSelectors'
import { yourPeergroupIdSelector, selectedPeergroupIdSelector } from 'selectors/peergroupSelectors'
import { GenericTrendOwnProps } from 'interfaces/trend'
import { createGuardOrderError } from 'helpers/errorHelpers'

export const memberGenericTrendsGuard: SimpleGuard<GenericTrendOwnProps> = {
  name: 'Member Generic Trend',
  checker: hasMemberGenericTrendSelector,
  loader: (dispatch, { type, timeframe }) =>
    dispatch(getMemberGenericTrendsActionCreator(type, timeframe)),
}

type PeergroupGenericTrendWatch = GenericTrendOwnProps & ActivePeergroupsTyped
export const peergroupGenericTrendsGuard: WatchingGuard<GenericTrendOwnProps, PeergroupGenericTrendWatch> = {
  name: 'Peer Group Generic Trend',
  checker: hasPeergroupGenericTrendsSelector,
  watcher: (state, ownProps) => {
    const peersId = yourPeergroupIdSelector(state)
    const othersId = selectedPeergroupIdSelector(state)

    return {
      ...ownProps,
      peersId,
      othersId,
    }
  },
  loader: (dispatch, { type, timeframe, peersId, othersId }) => {
    if (!isNumber(peersId) || !isNumber(othersId)) {
      throw createGuardOrderError('peergroupGenericTrendsGuard', 'peergroupsGuard')
    }

    dispatch(getPeergroupsGenericTrendsActionCreator(type, timeframe, [peersId, othersId]))
  },
}
